/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';

import { Flex, Box, Link } from '..';
import Picture from '../Picture';

export interface FooterSubNavProps {
  /**
   * Displays a list of links in a footer subnav.
   * @param {Object[]} links - list of sub nav links
   * @param {string} links[].label - display text of link
   * @param {string} links[].url - url link
   * @param {string} links[].[target] - determines if link should open
   * a new window
   */
  links: {
    label: string;
    url: string;
    target?: string;
  }[];
  logo?: string;
}

export const FooterSubNav = ({
  links,
  logo,
}: FooterSubNavProps): React.JSX.Element => (
  <Flex
    sx={{
      justifyContent: 'space-between',
      alignItems: ['start', null, null, 'center'],
      mb: [0, 3, null, 4],
      mt: [3, 4],
      bg: 'background',
      flexDirection: ['column', null, null, 'row'],
      lineHeight: ['footer', 'inherit'],
    }}
  >
    <Box sx={{ flex: [1, 0.9] }}>
      <Flex
        sx={{
          flexDirection: ['column', null, 'row'],
          flexWrap: ['nowrap', null, 'wrap'],
          justifyContent: 'space-between',
        }}
      >
        <Flex
          as="ul"
          sx={{
            flexDirection: ['column', null, null, 'row'],
            justifyContent: 'space-between',
            flex: '1 0 auto',
            columnGap: [null, null, null, '10px'],
          }}
        >
          {links &&
            links.map(({ label, url, target }) => (
              <li key={label}>
                <Link href={url} key={label} target={target} variant="footer">
                  {label}
                </Link>
              </li>
            ))}
        </Flex>
      </Flex>
    </Box>
    <Box sx={{ mt: [4, null, null, 0], maxWidth: '90px' }}>
      {logo && <Picture alt="Tishman Speyer" src={logo} />}
    </Box>
  </Flex>
);
